import { useFormikContext } from 'formik';
import CommonButton from '../../common-components/button/CommonButton';
import { useStore } from '../../../hooks/useStore';
import styles from './FormPopupFooter.module.css';

export type FormPopupFooterProps = {
  onClose: () => void;
  cancelLabel?: string;
  saveLabel?: string;
  submittingLabel?: string;
  onSave?: () => void;
};

export const FormPopupFooter = ({
  onClose,
  cancelLabel = 'İptal',
  saveLabel = 'Kaydet',
  submittingLabel = 'Kaydediliyor...',
  onSave,
}: FormPopupFooterProps) => {
  const { uiStore } = useStore();
  const formik = useFormikContext();
  const isSubmitting = formik.isSubmitting || uiStore.isLoading;
  const handleSave = onSave ?? formik.submitForm;

  return (
    <div className={styles.actions}>
      <CommonButton
        type="outline"
        className={styles.cancelBtn}
        onClick={onClose}
        disabled={isSubmitting}
      >
        {cancelLabel}
      </CommonButton>
      <CommonButton
        type="primary"
        className={styles.saveBtn}
        onClick={handleSave}
        disabled={isSubmitting}
        loading={isSubmitting}
      >
        {isSubmitting ? submittingLabel : saveLabel}
      </CommonButton>
    </div>
  );
};

export default FormPopupFooter;
